/**
 * Created by Christof Sander on 07.12.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					if(operation === 'move_node'){
						var treesComponent;
						if(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees')))){
							var nodeData = treesComponent.getNodeData(node.id);
							var parentNodeData;
							if(node_parent.id !== '#') parentNodeData = treesComponent.getNodeData(node_parent.id);

							result = (
								(
									node.type === 'component'
									&&
									node_parent.type === 'group'
								)
								||
								(
									node.type !== 'group'
									&&
									node_parent.id !== '#'
									&&
									(
										// template atoms and section can only be moved into components
										(
											(
												nodeData.templateAtomID !== undefined
												||
												nodeData.sectionID !== undefined
											)
											&&
											parentNodeData !== undefined
											&&
											parentNodeData.componentID !== undefined
										)
										||
										// move components to root or other components
										(
											nodeData.componentID !== undefined
											&&
											(
												!parentNodeData
												||
												parentNodeData.componentID !== undefined
											)
										)
									)
								)
							);
						}
					}
					return result;
				}
			}
			// plugins: [
			// 'contextmenu', 'dnd', 'search',
			// 'state', 'types', 'wholerow'
			// 'state',
			// 'types',
			// 'checkbox'
			// 'contextmenu',
			// 'dnd'
			// ]
		}
	}
};
